<template>
  <header>
    <p v-if="isLogin" id="user">
      <router-link :to="{ name: 'Account' }">
        <img src="/img/ico_user.png" alt="user">
      </router-link>
    </p>
    <p id="languageButton">
      <a class="text-white border-button pr05 pt05 pb05 pl05" @click="changeLanguage">{{$t('changeLanguage')}}</a>
    </p>
    <h1 id="logo"><a href="/"><img src="@/assets/img/logo.png" alt="CHOY-SAN"></a></h1>
  </header>
</template>

<script>
import i18n from '../i18n'

export default {
  name: 'Header',
  props: {
    isLogin: Boolean
  },
  methods:{
    changeLanguage(){
      if(i18n.locale=="en")
      {
        i18n.locale="ja";
        localStorage.locale="ja";
      }
      else
      {
        i18n.locale="en";
        localStorage.locale="en";
      }
    }
  }
}
</script>

<style scoped>
.border-button{
	width: fit-content;
	text-align: center;
	border: 1px solid #fff;
	border-radius: 6px;
}
#languageButton{
	float: right;
  margin-right: 20px;
}
@media screen and (max-width:640px){
  #languageButton{
    margin-top:8px;
    margin-right:5px;
}
}
</style>